//React imports
import React, { useEffect } from "react";

import FooterComponent from "../../components/home/FooterComponent.js";

//Imports assets such as images
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import CashbackSuccessComponent from "../../components/solutions/cashbackInfo/cashbackSuccess.jsx";

export default function CashbackSuccessPage() {
    return (
        <div>
            <div className="updated-page-wrapper">
                <div className="">

                    <NavBarComponent />
                </div>

                {/* <HeaderComponent page="pricing" /> */}


                <CashbackSuccessComponent />



                <FooterComponent />
            </div>
        </div>
    );
}
